/**
 * atomberg-free-installation.js
 *
 * Hides the free installation card while the delivery check in the same
 * section shows a not-serviceable pincode or an out-of-stock variant — the
 * promise only holds where the product is delivered. Every other state
 * (nothing checked, typing, serviceable, Change) shows it.
 */
(function () {
  'use strict';

  var w = /** @type {any} */ (window);
  if (w._atombergFreeInstallationInit) return;
  w._atombergFreeInstallationInit = true;

  function initAll() {
    var state = w.AtombergDeliveryState;
    if (!state) return;
    document.querySelectorAll('[data-atomberg-free-installation]').forEach(function (el) {
      var card = /** @type {any} */ (el);
      if (card._afiBound) return;
      card._afiBound = true;
      state.subscribe(card, function (/** @type {string} */ s) {
        card.hidden = s === 'unserviceable' || s === 'unavailable';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:load', initAll);
})();
